import { getFormattedDate } from '@app/utils/date'
import { objectOmitProperties } from '@app/utils/object'

import { dateFormat } from '@app/constants'

import type { EntityDto, ResponseDto } from '@app/api/dtos'
import type { ProductPricingDto } from '@app/api/routes/pricing/dtos'
import type { TableData } from '@app/types/table'
import type { ProductPricingListDataSource } from '@app/pages/TransferResultsPage/types'
import type { GetProductPricingListParams, PostPricingToolsSendData } from '@app/api/routes/pricing/types'

const getEntityNamesToString = (entityItems?: EntityDto[] | null): string | null => {
  return entityItems?.map(({ name }) => name)?.join(', ') ?? null
}

export const adaptProductPricingTableData = (
  resultsResponse: ResponseDto<ProductPricingDto>
): TableData<ProductPricingListDataSource> => {
  const { count, results } = resultsResponse

  const dataSource: ProductPricingListDataSource[] = results.map(dto => ({
    key: dto.id,
    productCode: dto?.product?.code ?? null,
    monitoringKind: getEntityNamesToString(dto?.monitoringKinds),
    monitoringType: getEntityNamesToString(dto?.monitoringTypes),
    name: dto?.product?.name ?? null,
    purchasingGroup: dto?.purchasingGroup?.name ?? null,
    category: dto.category?.name ?? null,
    categoryId: dto.category?.id ?? null,
    isShortKvi: dto.isShortKvi,
    isEPP: dto.isEPP,
    cluster: dto?.cluster?.name ?? null,
    store: dto?.store?.name ?? null,
    monitoringStartAt: getFormattedDate(dto.monitoringStartAt, dateFormat.DD_MM_YYYY),
    deadline: getFormattedDate(dto.deadline, dateFormat.DD_MM_YYYY),
    sentAt: getFormattedDate(dto.sentAt, dateFormat.DD_MM_YYYY),
    state: dto.state
  }))

  return { count, dataSource }
}

export const adaptPricingToolsSendData = (queryFilters?: GetProductPricingListParams): PostPricingToolsSendData => {
  const excludedQueryKeys = ['productCodes', 'productNames', 'deadlineBefore', 'deadlineAfter']

  return objectOmitProperties(queryFilters, excludedQueryKeys)
}
